const config = {
  env: 'DEV',
  firebaseConfig: {
    apiKey: 'AIzaSyDDFtkMGaYYd19PilvWPEAr0DpoWRWuwI8',
    authDomain: 'elret-dev.firebaseapp.com',
    projectId: 'elret-dev',
    storageBucket: 'elret-dev.firebasestorage.app',
    messagingSenderId: '876282764458',
    appId: '1:876282764458:web:cb4429786a5a5eea4c84d3'
  },
  siteId: 'elret-devel',
  uiBaseUrl: 'https://elret-devel.web.app/',
  apiBaseUrl: 'http://localhost:5001/elret-dev/us-central1/api/api',
  fiServEnvUrl: 'https://ais-ui-uat.fiservapps.com/alldata/',
  intercomAppId: 'qlijpicu',
};

export default config;
